import axios from "axios";
import { domain } from "../../../Links/Links";
import { getCookie } from "../../../../App";

export async function bankAccountAdditionRequest(
  nameInputValue,
  cardNumberValue,
  cardNumber2Value,
  setRequestStatus,
  setData,
  setAddBankAccountsStatus,
) {
  setRequestStatus(true);
  const data = {
    name: nameInputValue,
    card_number: cardNumberValue,
    card_number2: cardNumber2Value,
  };
  const response = await axios.post(domain + "/add_bank_account/", data, {
    withCredentials: true,
    headers: {
        'X-CSRFToken': getCookie('csrf_token'),
    }
  });

  if (response.data.ok == true) {

    setRequestStatus(false);
    setData((prev) => [data, ...prev]);
    setAddBankAccountsStatus(false);

  }
}
